import {createRouter,createWebHashHistory} from "vue-router"


import index from '@/view/index'
import list from '@/view/item/list'
import user from '@/view/user/user'
import login from '@/view/user/login'
import password from '@/view/user/password'

const routes = [
	{
	  path: '/',
	  name: 'index',
	  component: index,
	  meta:{
        title: '首页',
		keepAlive: true,
		isBack: false,
		color: '#f7f7f7'
      }
	},

	{
	  path: '/list',
	  name: 'list',
	  component: list,
	  meta:{
	    title: '订单列表',
		keepAlive: false,
		color: '#f7f7f7'
	  }
	},
	{
	  path: '/user',
	  name: 'user',
	  component: user,
	  meta:{
	    title: '个人资料',
		keepAlive: false,
		color: '#5484EA'
	  }
	},
	{
	  path: '/login',
	  name: 'login',
	  component: login,
	  meta:{
	    title: '登录',
		keepAlive: false,
		color: '#5484EA'
	  }
	},
	{
	  path: '/password',
	  name: 'password',
	  component: password,
	  meta:{
	    title: '修改密码',
		keepAlive: false,
		color: '#f5f3f0'
	  }
	},
]

export const router = createRouter({
	history: createWebHashHistory(),
	routes: routes
})


export default router
